// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Iran */
const IR =
  /^(?:9(?:(?:0[0-5]|[13]\d|2[0-3])\d\d|9(?:[0-46]\d\d|5(?:10|5\d)|8(?:[12]\d|3[0-2]|88)|9(?:[01359]\d|21|69|77|8[7-9])))\d{5})$/;

export default IR;
